export class mdlEmailOtpVerifyReq{
    public RegNo: string;
    public InsuredEmailId: string;
    public OTP: string;
    public Lang: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlEmailOtpVerifyReq.ts